import React from 'react';
import Portal from '../portal/Portal';

export const SpinnerPortal: React.FC<{ usePortal: boolean }> = ({
  usePortal,
  children,
}): JSX.Element =>
  !usePortal ? <>{children}</> : <Portal position="fixed">{children}</Portal>;
